import get from 'lodash/get';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../../utils/redux';

import { consts as updatePatientInsuranceConsts } from './update-patient-insurance';
import { consts as createPatientInsuranceConsts } from './create-patient-insurance';

export const consts = createReqConsts(
  'patient',
  'get-patient-insurances-list',
  ['REMOVE_PATIENT_INSURANCE_FROM_LIST'],
);

export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'patient_insurances',
    {
      type: 'payload.query',
      queryParameter: 'todo_task_assignment_id',
      selector: 'todoTaskAssignmentId',
    },
  ],
});

const defaultRequestReducer = createReqReducer(consts);

export default function(state = initialState, action) {
  switch (action.type) {
    case updatePatientInsuranceConsts.SUCCEED: {
      const list = get(state, 'list', []);

      const newList = list.map(item =>
        item.id === action.payload.id ? action.payload : item,
      );

      return {
        ...state,
        list: newList,
      };
    }

    case createPatientInsuranceConsts.SUCCEED: {
      const newList = [...state.list, action.payload];

      return {
        ...state,
        list: newList,
      };
    }

    case consts.REMOVE_PATIENT_INSURANCE_FROM_LIST: {
      const newList = state.list.filter(item => item.id !== action.payload.id);

      return {
        ...state,
        list: newList,
      };
    }

    default: {
      return defaultRequestReducer(state, action);
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/requests/get-patient-insurances-list.js